export default __webpack_public_path__ + "static/media/story-icon.2075475d.svg";